export default __webpack_public_path__ + "static/media/stacked-vertical-bar-chart.72c1611e.svg";